import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { AuthenticationRoutes } from './authentication.routing';
import { AppBoxedRegisterComponent } from './boxed-register/boxed-register.component';
import { AppBoxedTwoStepsComponent } from './boxed-two-steps/boxed-two-steps.component';
import { AppErrorComponent } from './error/error.component';
import { AppMaintenanceComponent } from './maintenance/maintenance.component';
import { AppSideForgotPasswordComponent } from './side-forgot-password/side-forgot-password.component';
import { AppSideLoginComponent } from './side-login/side-login.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SuccessRegisterComponent } from './boxed-register/components/success-register/success-register.component';
import { TermConditionsComponent } from './boxed-register/components/modal/term-conditions/term-conditions.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { DashboardsModule } from '../dashboards/dashboards.module';
import { UicomponentsModule } from '../ui-components/ui-components.module';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { environment } from 'src/environments/enviroments';
import { MaterialModule } from 'src/app/material.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  RecaptchaModule,
  ReCaptchaV3Service,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaV3Module,
  RecaptchaFormsModule,
} from 'ng-recaptcha';
import { CookieService } from 'ngx-cookie-service';
import { ProcessDataComponent } from './process-data/process-data.component';
import { ChangePasswordComponent } from './side-login/modal/change-password/change-password.component';
import { TokenInterceptor } from 'src/app/services/token.interceptor';
import { MatSliderModule } from '@angular/material/slider';

@NgModule({ declarations: [
        SuccessRegisterComponent,
        TermConditionsComponent,
        AppBoxedRegisterComponent,
        ProcessDataComponent,
        AppSideLoginComponent,
        ChangePasswordComponent,
    ], imports: [CommonModule,
        RouterModule.forChild(AuthenticationRoutes),
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        FormsModule,
        MatSelectModule,
        ReactiveFormsModule,
        TablerIconsModule.pick(TablerIcons),
        SweetAlert2Module.forRoot(),
        MatDialogModule,
        UicomponentsModule,
        MaterialModule,
        RecaptchaModule,
        RecaptchaV3Module,
        RecaptchaFormsModule,
        AppErrorComponent,
        AppMaintenanceComponent,
        MatTableModule], providers: [
        CookieService,
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.recaptcha.siteKey,
        },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AuthenticationModule {}
